var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bizcomp-bind-new-acct bizcomp"},[_c('bind-acct-dc',{attrs:{"way":_vm.way}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }